import { render } from "./LaddarSymbol.vue?vue&type=template&id=7385a1bb&scoped=true"
const script = {}

import "./LaddarSymbol.vue?vue&type=style&index=0&id=7385a1bb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7385a1bb"]])

export default __exports__